import React from "react";

function CardViewIcon({style={}}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" {...style}>
            <path
                d="M10.25 2.75C10.25 1.7835 11.0335 1 12 1H13.75C14.7165 1 15.5 1.7835 15.5 2.75V4.5C15.5 5.4665 14.7165 6.25 13.75 6.25H12C11.0335 6.25 10.25 5.4665 10.25 4.5V2.75Z"
                stroke="currentColor"
                strokeWidth="1.03448"
            />
            <path
                d="M1.5 11.5C1.5 10.5335 2.2835 9.75 3.25 9.75H5C5.9665 9.75 6.75 10.5335 6.75 11.5V13.25C6.75 14.2165 5.9665 15 5 15H3.25C2.2835 15 1.5 14.2165 1.5 13.25V11.5Z"
                stroke="currentColor"
                strokeWidth="1.03448"
            />
            <path
                d="M1.5 2.75C1.5 1.7835 2.2835 1 3.25 1H5C5.9665 1 6.75 1.7835 6.75 2.75V4.5C6.75 5.4665 5.9665 6.25 5 6.25H3.25C2.2835 6.25 1.5 5.4665 1.5 4.5V2.75Z"
                stroke="currentColor"
                strokeWidth="1.03448"
            />
            <path
                d="M10.25 11.5C10.25 10.5335 11.0335 9.75 12 9.75H13.75C14.7165 9.75 15.5 10.5335 15.5 11.5V13.25C15.5 14.2165 14.7165 15 13.75 15H12C11.0335 15 10.25 14.2165 10.25 13.25V11.5Z"
                stroke="currentColor"
                strokeWidth="1.03448"
            />
        </svg>
    );
}

export default CardViewIcon;
